import { render, staticRenderFns } from "./ReviewCalving.vue?vue&type=template&id=ab3b99da&"
import script from "./ReviewCalving.vue?vue&type=script&lang=js&"
export * from "./ReviewCalving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports